import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import { toColor } from 'utils'

const TemplateList = ({ templates }) => (
  <div className="w-full px-4 sm:px-6 lg:max-w-6xl lg:px-8">
    <div className="sm:grid sm:grid-cols-2 sm:gap-2">
      { templates
          .filter(({ meta: { parentId } }) => !parentId)
          .map(({ meta: { name, description, hashId } }, i) => (
        <Link key={name} to={`/orders/new/${hashId}`} className={`relative group border border-gray-200 shadow-sm rounded-sm bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:${toColor(name)}`} tabIndex={i + 1}>
          <div>
            <span className={`rounded-lg inline-flex p-3 ${toColor(name)} ${toColor(name, 'text')} ring-4 ring-white`}>
              <Icon icon="plus" className="text-white" />
            </span>
          </div>
          <div className="mt-8">
            <h3 className="text-lg font-medium focus:text-white">
              <span className="absolute inset-0 " aria-hidden="true"></span>
              { name }
            </h3>
            <p className="mt-2 text-sm text-gray-500 focus:text-white">
              { description }
            </p>
          </div>
          <span className="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400" aria-hidden="true">
            <Icon icon="chevron-right" />
          </span>
        </Link>
      )) }
    </div>
  </div>
)

export default TemplateList
